export default __webpack_public_path__ + "static/media/Arrow.26b22f94.svg";